import "./Footer.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

export default function Footer() {
  return (
    <footer className="site-footer" id="Footer">
      <div className="footer-inner container">
        <div className="col brand">
          <h4 className="brand-title">AITAM's GoKart Championship</h4>
          <p className="brand-desc">
            The premier racing event unites the finest Drivers to compete in multiple high-intensity and skill-based challenges.
            
          </p>
          <div className="socials" aria-label="social links">
            <a className="social" href="https://www.facebook.com/AITAMOfficial/" aria-label="Facebook"><i className="fa-brands fa-facebook-f"></i></a>
            <a className="social" href="https://x.com/AitamOfficial" aria-label="Twitter"><i className="fa-brands fa-x-twitter"></i></a>
            <a className="social" href="https://www.instagram.com/agkc_2k26/" aria-label="Instagram"><i className="fa-brands fa-instagram"></i> </a>
            <a className="social" href="youtube.com/@aitamofficial" aria-label="YouTube"><i className="fa-brands fa-youtube"></i></a>
          </div>
        </div>

        <div className="col links">
          <h5>Important Links</h5>
          <ul>
            <li><a href="https://docs.google.com/forms/d/e/1FAIpQLScZnKBW10oTRiaRK-kyb5OuCh94Zm4mnwII7zRU_lGMmDqQYA/viewform"  target="_blank" 
                     rel="noopener noreferrer" >Registration</a></li>
            <li><a href="https://drive.google.com/drive/folders/1pMJIOMPz0dr1__CRXZ5oaRm1ZoAKipi0?usp=drive_link"  target="_blank" 
                     rel="noopener noreferrer" >Rules & Regulations</a></li>
          </ul>
        </div>

        <div className="col points">
          <h5>Important Points</h5>
          <ul>
            <li>Valid racing license required for participation</li>
            <li>All safety equipment must meet championship standards</li>
            <li>Registration closes 48 hours before each event</li>
            <li>Minimum age requirement: 18 years</li>
          </ul>
        </div>
        <div className="col contact">
          <h5>Contact Us</h5>
          <div className="contact-row"><span className="icon"><i className="fa-regular fa-envelope"></i></span><a id="lnk" href="agkc@adityatekkali.edu.in">info@gokartchampionship.com</a></div>
          <div className="contact-row"><span className="icon"><i className="fa-solid fa-phone"></i></span><a id="lnk" href="tel:+1234567890">9121563613/9989958687<br/>Mahesh/Murari</a></div>
          <div className="contact-row"><span className="icon"><i className="fa-solid fa-location-dot"></i></span>
            <address>K Kotturu Village, Tekkali,<br/>Srikakulam, A.P 532201 ·</address>
          </div>
        </div>
      </div>

      <div className="footer-bottom container">
        <div className="copyright">© Designed and Devloped By <span className="high">Developers Club </span> from <a  className="high" href="https://aitamsac.in/ssc/index.php">SSC</a> . All Rights Reserved</div>
      </div>
    </footer>
  );
}
